import { useEffect, useState } from "react";
import { postAxios } from "../../util/apiCall";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";
import {
  formatDot,
  switchDotsAndCommas,
  numberWithCommas,
  hasRole,
} from "../../util/utilFunction";
import * as XLSX from "xlsx";
import axios from "axios";
import { buildOpenMemoItems } from "./poMemoHelpers";

export const usePO = () => {
  const dataAuth = localStorage.getItem("auth");
  const dataUser = JSON.parse(dataAuth);

  const checkingRole = hasRole(
    dataUser,
    "super_user",
    "ppic_user",
    "warehouse_gbj_admin"
  )
    ? true
    : false;

  const [popUpNewPo, setPopUpNewPo] = useState(false);

  const [customerNewPo, setCustomerNewPo] = useState("Pilih Customer");
  const [noPo, setNoPo] = useState();
  const [noLine, setNoLine] = useState();
  const [noSkk, setNoSkk] = useState();
  const [kodeLine, setKodeLine] = useState();
  const [itemPo, setItemPo] = useState();
  const [totalPo, setTotalPo] = useState();

  const [dataListTempPo, setDataListTempPo] = useState([]);
  const [errIsEmpty, setErrIsEmpty] = useState(false);

  const [popUpImportPo, setPopUpImportPo] = useState(false);

  const [bulanPo, setBulanPo] = useState(
    moment().utcOffset("+0700").month() + 1
  );

  const [jadwalKirim, setJadwalKirim] = useState([
    {
      date: moment()
        .utcOffset("+0700")
        .set("month", Number(bulanPo) - 1)
        .format("YYYY-MM-DD"),
      jumlah: 0,
      noPol: "",
    },
  ]);
  const [tahunPo, setTahunPo] = useState(moment().utcOffset("+0700").year());

  const [dataListBarang, setDataListBarang] = useState();
  const [dataListPo, setDataListPo] = useState();

  const [isEditPo, setIsEditPo] = useState(false);

  const [popUpPickTanggal, setPopUpPickTanggal] = useState(false);
  const [pickTanggal, setPickTanggal] = useState();
  const [pickData, setPickData] = useState();

  const [isRefresh, setIsRefresh] = useState(false);

  const [dateKirim, setDateKirim] = useState();
  const [jumlahKirim, setJumlahKirim] = useState();
  const [jumlahBefore, setJumlahBefore] = useState();
  const [dateBefore, setDateBefore] = useState();
  const [isMaju, setIsMaju] = useState(false);
  const [isMundur, setIsMundur] = useState(false);

  const [isBuatMemoKirim, setIsBuatMemoKirim] = useState(false);

  const [popUpCatatan, setPopUpCatatan] = useState(false);

  const [customerCatatan, setCustomerCatatan] = useState("Pilih Customer");
  const [keteranganCatatan, setKeteranganCatatan] = useState("");
  const [dataListCatatan, setDataListCatatan] = useState();
  const [dataSuratJalanTemp, setDataSuratJalanTemp] = useState([]);
  const [dataPickMemoKirim, setDataPickMemoKirim] = useState([]);

  const [isRefreshCatatan, setIsRefreshCatatan] = useState(false);
  const [isRefreshMemoKirim, setIsRefreshMemoKirim] = useState(false);

  const [isPecah, setIsPecah] = useState(false);
  const [isPecahPick, setIsPecahPick] = useState();
  const [errPecah, setErrPecah] = useState(false);

  const [dateMemoKirim, setDateMemoKirim] = useState(
    moment()
      .utcOffset("+0700")
      .set("month", Number(bulanPo) - 1)
      .format("YYYY-MM-DD")
  );

  const [pecahNoPol, setPecahNoPol] = useState([
    {
      date: moment()
        .utcOffset("+0700")
        .set("month", Number(bulanPo) - 1)
        .format("YYYY-MM-DD"),
      noPol: "",
      jumlah: null,
    },
  ]);

  const [noPol, setNoPol] = useState();

  const [subMenu, setSubMenu] = useState("Input");
  const [dataListMemo, setDataListMemo] = useState();

  const [filterDateMemoKirim, setFilterDateMemoKirim] = useState(
    moment().utcOffset("+0700").format("YYYY-MM-DD")
  );

  const [filterCustomer, setFilterCustomer] = useState("Pilih Customer");
  const [valueSearch, setValueSearch] = useState("");
  const [valueSearchMemo, setValueSearchMemo] = useState("");

  const [dataMirrorMemoKirim, setDataMirrorMemoKirim] = useState();
  const [dataMirrorSj, setDataMirrorSj] = useState();
  const [isRefreshMantap, setIsRefreshMantap] = useState(false);

  const [disabledButton, setDisabledButton] = useState(false);
  const [dataBarangJadi, setDataBarangJadi] = useState();

  const [file, setFile] = useState(null);

  /* ---------- state baru: checklist memo -> surat jalan ---------- */
  const [selectedMemoIds, setSelectedMemoIds] = useState([]);

  /* ---------- state baru: tiket cancellation ---------- */
  const [popUpCancel, setPopUpCancel] = useState(false);
  const [cancelNoSj, setCancelNoSj] = useState("");
  const [cancelType, setCancelType] = useState("internal");
  const [cancelReason, setCancelReason] = useState("");
  const [cancelItems, setCancelItems] = useState([]);
  const [errCancel, setErrCancel] = useState("");

  /* ---------- state baru: riwayat ---------- */
  const [dataHistoryCancel, setDataHistoryCancel] = useState([]);
  const [isRefreshHistory, setIsRefreshHistory] = useState(false);
  const [filterBulanHistory, setFilterBulanHistory] = useState(
    moment().utcOffset("+0700").format("YYYY-MM")
  );

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getCatatan`,
      {
        tim: dataUser.tim,
        type: "get",
        date: filterDateMemoKirim,
      },
      dataUser.auth,
      setDataListCatatan,
      ""
    );
    setIsRefreshCatatan(false);
  }, [isRefreshCatatan, filterDateMemoKirim, subMenu]);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListBarangPO`,
      {
        tim: dataUser.tim,
      },
      dataUser.auth,
      setDataListBarang,
      ""
    );
  }, []);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListPO`,
      {
        tim: dataUser.tim,
        filterDate: `${tahunPo}-${("0" + bulanPo).slice(-2)}`,
      },
      dataUser.auth,
      setDataListPo,
      ""
    );
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getListBarangJadi`,
      { tim: dataUser.tim, type: "listBarangJadi" },
      dataUser.auth,
      setDataBarangJadi,
      ""
    );
    setIsRefresh(false);
  }, [tahunPo, bulanPo, isRefresh, isRefreshMemoKirim, subMenu]);

  // ganti tanggal -> pilihan checklist di-reset
  useEffect(() => {
    setSelectedMemoIds([]);
  }, [filterDateMemoKirim]);

  // ambil riwayat saat tab Riwayat dibuka / filter berubah
  useEffect(() => {
    if (subMenu === "Riwayat") {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/getHistoryCancellation`,
        { tim: dataUser.tim, filterDate: filterBulanHistory },
        dataUser.auth,
        setDataHistoryCancel,
        ""
      );
    }
    setIsRefreshHistory(false);
  }, [subMenu, filterBulanHistory, isRefreshHistory]);

  const addFields = () => {
    let newfield = {
      date: moment()
        .utcOffset("+0700")
        .set("month", Number(bulanPo) - 1)
        .format("YYYY-MM-DD"),
      jumlah: 0,
      noPol: "",
    };
    setJadwalKirim([...jadwalKirim, newfield]);
  };

  const removeFields = () => {
    let data = [...jadwalKirim];
    data.splice(data.length - 1);
    setJadwalKirim(data);
  };

  const handleFormChange = (index, event) => {
    let data = [...jadwalKirim];
    if (event.target.name === "jumlah") {
      data[index][event.target.name] = Number(event.target.value);
    } else {
      data[index][event.target.name] = event.target.value;
      data[index][`tanggal`] = moment(event.target.value)
        .utcOffset("+0700")
        .format("DD");
    }
    setJadwalKirim(data);
  };

  const handleCloseNewPo = () => {
    setJadwalKirim([
      {
        date: moment()
          .utcOffset("+0700")
          .set("month", Number(bulanPo) - 1)
          .format("YYYY-MM-DD"),
        jumlah: 0,
        noPol: "",
      },
    ]);
    setCustomerNewPo("Pilih Customer");
    setNoPo();
    setNoLine();
    setNoSkk();
    setKodeLine();
    setItemPo();
    setTotalPo();
    setPopUpNewPo(false);
    setDataListTempPo([]);
    setErrIsEmpty(false);
    setBulanPo(moment().utcOffset("+0700").month() + 1);
    setTahunPo(moment().utcOffset("+0700").year());
    setIsRefresh(true);
    setIsRefreshMemoKirim(true);
    setDisabledButton(false);
  };

  const handleTambahPo = () => {
    if (!disabledButton) {
      if (customerNewPo !== "Pilih Customer" && itemPo && totalPo) {
        const foundObject =
          dataListTempPo &&
          dataListTempPo.find(
            (obj) => obj.itemPo === itemPo.name && obj.noPo === noPo
          );

        let findIfNameExist =
          dataListTempPo &&
          dataListTempPo.findIndex(function (obj) {
            return obj.itemPo === itemPo.name && obj.noPo === noPo;
          });
        const filteredArray = jadwalKirim.filter(
          (element) => element.jumlah !== 0
        );

        if (!foundObject) {
          setDataListTempPo([
            ...dataListTempPo,
            {
              id: uuidv4(),
              customer: customerNewPo,
              noPo: noPo,
              itemPo: itemPo.name,
              kodeBarang: itemPo.value,
              jumlah: totalPo,
              noLine: noLine,
              noSkk: noSkk,
              kodeLine: kodeLine,
              jadwalKirim: filteredArray,
            },
          ]);
        } else {
          let data = [...dataListTempPo];

          jadwalKirim &&
            jadwalKirim.forEach((element) => {
              if (element.jumlah !== 0) {
                data[findIfNameExist].jadwalKirim.push({
                  date: element.date,
                  jumlah: element.jumlah,
                  tanggal: moment(element.date).utcOffset("+0700").format("DD"),
                  noPol: "",
                });
                data[findIfNameExist].jumlah += element.jumlah;
              }
            });
          setDataListTempPo(data);
        }
        setItemPo();
        setTotalPo();
        setNoLine();

        setJadwalKirim([
          {
            date: moment()
              .utcOffset("+0700")
              .set("month", Number(bulanPo) - 1)
              .format("YYYY-MM-DD"),
            jumlah: 0,
            noPol: "",
          },
        ]);
        setErrIsEmpty(false);
        setDisabledButton(false);
      } else {
        setErrIsEmpty(true);
        setDisabledButton(false);
      }
    }
  };

  let dateTemp = [];

  dataListTempPo &&
    dataListTempPo.forEach((element) => {
      element &&
        element.jadwalKirim.forEach((ele) => {
          if (!dateTemp.some((el) => el.date === ele.date)) {
            dateTemp.push(ele);
          }
        });
    });

  const handleDeleteTempPo = (id) => {
    let data = [...dataListTempPo];
    data.splice(
      data.findIndex(function (i) {
        return i.id === id;
      }),
      1
    );

    setDataListTempPo(data);
  };

  const handleKirimPo = () => {
    if (!disabledButton) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/addNewPO`,
        {
          tim: dataUser.tim,
          dataListTempPo: dataListTempPo,
          filterDate: `${tahunPo}-${("0" + bulanPo).slice(-2)}`,
        },
        dataUser.auth,
        "",
        ""
      );
      setIsRefresh(true);
      handleCloseNewPo();
    }
  };

  let dataListBarangTemp = {};

  dataListBarang &&
    dataListBarang.forEach((element) => {
      if (element.company === customerNewPo) {
        dataListBarangTemp = element;
      }
    });

  let dateTempListPo = [];

  var days = moment(`${tahunPo}-${("0" + bulanPo).slice(-2)}`).daysInMonth();

  for (let index = 0; index < days; index++) {
    dateTempListPo.push({
      date: `${tahunPo}-${("0" + bulanPo).slice(-2)}-${(
        "0" +
        (index + 1)
      ).slice(-2)}`,
      tanggal: `${("0" + (index + 1)).slice(-2)}`,
    });
  }

  const handlePickTanggal = (data, tanggal, foundObject) => {
    if (checkingRole) {
      setJumlahBefore(foundObject && foundObject.jumlah);
      setPopUpPickTanggal(true);
      setPickTanggal(tanggal);
      setPickData({ ...data, dateBefore: foundObject });
      setDateKirim(tanggal.date);
      setDateBefore(tanggal.date);
      setJumlahKirim(foundObject && foundObject.jumlah);

      setIsMaju(foundObject && foundObject.isMaju);
      setIsMundur(foundObject && foundObject.isMundur);
    }
  };

  const handlePickJenis = (e) => {
    if (e === "maju") {
      setIsMundur(false);
      setIsMaju(true);
    } else if (e === "mundur") {
      setIsMundur(true);
      setIsMaju(false);
    }
  };

  const handleClosePopUpPickTanggal = () => {
    setPopUpPickTanggal(false);
    setJumlahKirim();
    setDateKirim();
    setPickData();
    setPickTanggal();
    setJumlahBefore();
    setDateBefore();
    setIsMaju(false);
    setIsMundur(false);
    setIsRefresh(true);
    setDisabledButton(false);
  };

  const handleKirimEditTanggal = () => {
    if (!disabledButton) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/editTanggalPO`,
        {
          tim: dataUser.tim,
          id: pickData.id,
          editDateKirim: dateKirim,
          dateBefore: dateBefore,
          editTanggal: moment(dateKirim).date().toString(),
          editJumlah: jumlahKirim,
          jumlahBefore: jumlahBefore ? jumlahBefore : 0,
          isMaju: isMaju,
          isMundur: isMundur,
        },
        dataUser.auth,
        "",
        ""
      );
      setIsRefresh(true);
      handleClosePopUpPickTanggal();
    }
  };

  const handleKirimBatal = () => {
    if (!disabledButton) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/batalPo`,
        {
          tim: dataUser.tim,
          id: pickData.id,
          editDateKirim: dateKirim,
          dateBefore: dateBefore,
          editTanggal: moment(dateKirim).date().toString(),
        },
        dataUser.auth,
        "",
        ""
      );
      setIsRefresh(true);
      handleClosePopUpPickTanggal();
    }
  };

  const handleCloseCatatan = () => {
    setKeteranganCatatan("");
    setCustomerCatatan("Pilih Customer");
    setIsRefreshCatatan(true);
    setDisabledButton(false);
  };

  const handleUpdateCatatan = () => {
    if (!disabledButton) {
      if (customerCatatan !== "Pilih Customer" && keteranganCatatan) {
        postAxios(
          `${process.env.REACT_APP_ENDPOINT}/getCatatan`,
          {
            tim: dataUser.tim,
            type: "update",
            date: filterDateMemoKirim,
            company: customerCatatan,
            desc: keteranganCatatan,
          },
          dataUser.auth,
          "",
          ""
        );
        setDisabledButton(false);
        setIsRefreshCatatan(true);
        handleCloseCatatan();
      } else {
        setDisabledButton(false);
      }
    }
  };

  const handleDeleteCatatan = (id) => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/getCatatan`,
      {
        tim: dataUser.tim,
        type: "delete",
        id: id,
      },
      dataUser.auth,
      "",
      ""
    );
    setIsRefreshCatatan(true);
    handleCloseCatatan();
    setIsRefreshCatatan(true);
  };

  useEffect(() => {
    setDataSuratJalanTemp(buildOpenMemoItems(dataListPo, dateMemoKirim));
    setIsRefreshMemoKirim(false);
  }, [dataListPo, isRefreshMemoKirim, dateMemoKirim]);

  const handlePickChecklist = (ele) => {
    let dataPick = [...dataSuratJalanTemp];

    dataPick.splice(
      dataPick.findIndex(function (i) {
        return i === ele;
      }),
      1
    );

    setDataSuratJalanTemp(dataPick);

    if (!isPecah) {
      setDataPickMemoKirim([
        ...dataPickMemoKirim,
        { ...ele, dateKirimFinal: dateMemoKirim, noPol: noPol },
      ]);
    } else {
      setDataPickMemoKirim([...dataPickMemoKirim, ele]);
    }
  };

  const handleCancelPickChecklist = (ele) => {
    let dataPick = [...dataPickMemoKirim];

    dataPick.splice(
      dataPick.findIndex(function (i) {
        return i === ele;
      }),
      1
    );

    setDataPickMemoKirim(dataPick);

    setDataSuratJalanTemp([...dataSuratJalanTemp, ele]);
  };

  const handleCloseMemoKirim = () => {
    setDataSuratJalanTemp([]);
    setDataPickMemoKirim([]);
    setIsBuatMemoKirim(false);
    setIsRefreshMemoKirim(true);
    setIsPecah(false);
    setIsPecahPick();
    setPecahNoPol([
      {
        date: moment()
          .utcOffset("+0700")
          .set("month", Number(bulanPo) - 1)
          .format("YYYY-MM-DD"),
        noPol: "",
        jumlah: null,
      },
    ]);
    setNoPol();
    setDisabledButton(false);
  };

  const addFieldsPecah = () => {
    let newfield = {
      date: moment().utcOffset("+0700").format("YYYY-MM-DD"),
      jumlah: null,
      noPol: "",
    };
    setPecahNoPol([...pecahNoPol, newfield]);
  };

  const removeFieldsPecah = () => {
    let data = [...pecahNoPol];
    if (data.length > 1) {
      data.splice(data.length - 1);
      setPecahNoPol(data);
    }
  };

  const removeSpaces = (inputElement, setState) => {
    let currentValue = inputElement;

    let newValue = currentValue.replace(/\s/g, "");

    if (setState) {
      setState(newValue);
    } else {
      return newValue;
    }
  };

  const handleFormChangePecah = (index, event, type) => {
    let data = [...pecahNoPol];
    if (type === "jumlah") {
      data[index][event.target.name] = Number(event.target.value);
      setPecahNoPol(data);
    } else if (type === "noPol") {
      data[index][event.target.name] = removeSpaces(
        event.target.value.toUpperCase()
      );
      setPecahNoPol(data);
    } else {
      data[index][event.target.name] = event.target.value;
      setPecahNoPol(data);
    }
  };

  const handleClickPecah = () => {
    const sum =
      pecahNoPol &&
      pecahNoPol.reduce(function (s, a) {
        return s + a.jumlah;
      }, 0);
    if (isPecahPick && sum === isPecahPick.data.jumlah) {
      let dataPick = [...dataSuratJalanTemp];

      let data = [];

      pecahNoPol &&
        pecahNoPol.forEach((element) => {
          data.push({
            customer: isPecahPick.data.customer,
            id: isPecahPick.data.id,
            isBatal: isPecahPick.data.isBatal,
            isKirim: isPecahPick.data.isKirim,
            itemPo: isPecahPick.data.itemPo,
            kodeBarang: isPecahPick.data.kodeBarang,
            noPo: isPecahPick.data.noPo,
            date: isPecahPick.data.date,
            noPol: element.noPol,
            jumlah: element.jumlah,
            dateKirimFinal: element.date,
          });
          const obj = {
            customer: isPecahPick.data.customer,
            date: isPecahPick.data.date,
            id: isPecahPick.data.id,
            itemPo: isPecahPick.data.itemPo,
            kodeBarang: isPecahPick.data.kodeBarang,
            jumlah: isPecahPick.data.jumlah,
            noPo: isPecahPick.data.noPo,
          };

          let findDataBarang = dataPick.filter(
            (item) =>
              item["customer"] === obj.customer &&
              item["date"] === obj.date &&
              item["id"] === obj.id &&
              item["itemPo"] === obj.itemPo &&
              item["kodeBarang"] === obj.kodeBarang &&
              item["jumlah"] === obj.jumlah &&
              item["noPo"] === obj.noPo
          );

          let findIndex = dataPick.findIndex(function (item) {
            return item === findDataBarang[0];
          });

          let calculate = findDataBarang[0].jumlah - element.jumlah;

          if (calculate > 0) {
            dataPick[findIndex][`jumlah`] = calculate;
          } else {
            dataPick.splice(
              dataPick.findIndex(function (i) {
                return (
                  i.customer === isPecahPick.data.customer &&
                  i.date === isPecahPick.data.date &&
                  i.id === isPecahPick.data.id &&
                  i.itemPo === isPecahPick.data.itemPo &&
                  i.kodeBarang === isPecahPick.data.kodeBarang &&
                  i.jumlah === isPecahPick.data.jumlah &&
                  i.noPo === isPecahPick.data.noPo
                );
              }),
              1
            );
          }
        });

      setDataSuratJalanTemp(dataPick);
      setDataPickMemoKirim([...dataPickMemoKirim, ...data]);

      setIsPecah(false);
      setIsPecahPick();
      setPecahNoPol([
        {
          date: moment().utcOffset("+0700").format("YYYY-MM-DD"),
          noPol: "",
          jumlah: null,
        },
      ]);
      setErrPecah(false);
    } else {
      setErrPecah(true);
    }
  };

  const handleKirimNoPol = () => {
    if (!disabledButton) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/kirimPO`,
        {
          tim: dataUser.tim,
          data: dataPickMemoKirim,
        },
        dataUser.auth,
        "",
        ""
      );
      handleCloseMemoKirim();
    }
  };

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/memoKirim`,
      {
        tim: dataUser.tim,
        type: "get",
        date: filterDateMemoKirim,
      },
      dataUser.auth,
      setDataListMemo,
      ""
    );
    setIsRefreshMemoKirim(false);
  }, [subMenu, filterDateMemoKirim, isRefreshMemoKirim]);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/memoKirim`,
      {
        tim: dataUser.tim,
        type: "get",
        date: filterDateMemoKirim,
      },
      dataUser.auth,
      setDataMirrorMemoKirim,
      ""
    );

    setIsRefreshMantap(false);
    setIsRefresh(false);
  }, [subMenu, filterDateMemoKirim, isRefreshMantap, isRefresh]);

  useEffect(() => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/memoKirim`,
      {
        tim: dataUser.tim,
        type: "get",
        date: filterDateMemoKirim,
      },
      dataUser.auth,
      setDataMirrorSj,
      ""
    );

    setIsRefreshMantap(false);
    setIsRefresh(false);
  }, [subMenu, filterDateMemoKirim, isRefreshMantap, isRefresh]);

  // Berdasarkan _id (bukan index) karena tab Memo memfilter baris.
  // Cabang noSkk ditambahkan (versi lama tidak pernah menyimpan perubahan SKK).
  const handleFormChangeEditNoPol = (id, event, type) => {
    if (!checkingRole) return;
    const data = (dataListMemo || []).map((row) => {
      if (row._id !== id) return row;
      if (type === "noPol") {
        return {
          ...row,
          noPol: removeSpaces(event.target.value.toUpperCase()),
        };
      }
      if (type === "noSkk") {
        return { ...row, noSkk: event.target.value.toUpperCase() };
      }
      if (type === "keterangan") {
        return { ...row, keterangan: event.target.value };
      }
      if (type === "isPelengkap") {
        return { ...row, isPelengkap: event.target.checked };
      }
      return row;
    });
    setDataListMemo(data);
  };

  const handleSaveNoPol = () => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/memoKirim`,
      {
        tim: dataUser.tim,
        type: "update",
        data: dataListMemo,
      },
      dataUser.auth,
      "",
      ""
    );
    setIsRefreshMantap(true);
    setIsRefresh(true);
  };

  const handleExportExcel = () => {
    const filteredDataExcel =
      dataListMemo &&
      dataListMemo
        .filter((e) => e.isBatal || Number(e.jumlah) > 0) // baris jumlah 0 = SJ yang dibatalkan penuh
        .map((obj, index) => {
          let regex = /^[0-9]$/;
          let firstChar = obj.kodeBarang.charAt(0);

          if (obj.isBatal) {
            return {};
          } else {
            return {
              "TGL. SJ": moment(obj.dateKirimFinal)
                .utcOffset("+0700")
                .format("DD-MM-YYYY"),
              "NO. SJ": obj && obj.noSj,
              "NO. PO.": obj && obj.noPo,
              "KODE BARANG": regex.test(firstChar)
                ? `'${obj.kodeBarang}`
                : obj.kodeBarang,
              "NAMA BARANG": obj.itemPo,
              CUST: obj.customer,
              "JUMLAH BARANG": formatDot(
                switchDotsAndCommas(numberWithCommas(obj.jumlah))
              ),
            };
          }
        });

    const workSheet = XLSX.utils.json_to_sheet(
      filteredDataExcel && filteredDataExcel
    );

    workSheet["!cols"] = [
      { wch: 10 },
      { wch: 15 },
      { wch: 16 },
      { wch: 47 },
      { wch: 47 },
      { wch: 5 },
      { wch: 15 },
    ];
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "Kiriman");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(
      workBook,
      `KIRIMAN ${moment(filterDateMemoKirim)
        .utcOffset("+0700")
        .format("DD-MM-YYYY")}.xlsx`
    );
  };

  const handleDeleteMemoKirim = (data) => {
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/memoKirim`,
      {
        tim: dataUser.tim,
        type: "delete",
        data: data,
      },
      dataUser.auth,
      "",
      ""
    );
    setIsRefreshMemoKirim(true);
  };

  const searchFeature = (params) => {
    if (valueSearch !== "" && filterCustomer === "Pilih Customer") {
      let searchName = [];
      dataListPo &&
        dataListPo.forEach((value) => {
          let checkItemPo = value.itemPo
            ? value.itemPo.toLowerCase().includes(params.toLowerCase())
            : null;
          let checkNoPo = value.noPo
            ? value.noPo.includes(params.toLowerCase())
            : null;

          if (checkItemPo || checkNoPo) {
            searchName.push(value);
          }
        });
      return searchName;
    } else if (valueSearch === "" && filterCustomer !== "Pilih Customer") {
      let searchName = [];
      dataListPo &&
        dataListPo.forEach((value) => {
          if (value.customer === filterCustomer) {
            searchName.push(value);
          }
        });
      return searchName;
    } else if (valueSearch !== "" && filterCustomer !== "Pilih Customer") {
      let searchName = [];
      dataListPo &&
        dataListPo.forEach((value) => {
          let checkItemPo = value.itemPo
            ? value.itemPo.toLowerCase().includes(params.toLowerCase())
            : null;
          let checkNoPo = value.noPo
            ? value.noPo.includes(params.toLowerCase())
            : null;

          if (value.customer === filterCustomer && checkItemPo) {
            searchName.push(value);
          }
          if (checkNoPo) {
            searchName.push(value);
          }
        });
      return searchName;
    } else {
      return dataListPo && dataListPo;
    }
  };
  let dataTemp = searchFeature(valueSearch);

  const searchFeatureMemo = (params) => {
    if (valueSearchMemo !== "") {
      let searchName = [];
      dataListMemo &&
        dataListMemo.forEach((value) => {
          const find1 = value.itemPo
            .toLowerCase()
            .includes(params.toLowerCase());

          const find2 = value.noPo.toLowerCase().includes(params.toLowerCase());
          const find3 = value.noSj
            ? value.noSj.toLowerCase().includes(params.toLowerCase())
            : false;

          // satu baris hanya dimasukkan sekali walau cocok di beberapa field
          if (find1 || find2 || find3) {
            searchName.push(value);
          }
        });
      return searchName;
    } else {
      return dataListMemo && dataListMemo;
    }
  };
  let dataTempMemoSearch = searchFeatureMemo(valueSearchMemo);

  const handleResetFilter = (params) => {
    setFilterCustomer("Pilih Customer");
    setValueSearch("");
  };

  const handleDeleteJadwal = () => {
    if (!disabledButton) {
      postAxios(
        `${process.env.REACT_APP_ENDPOINT}/deleteJadwal`,
        {
          tim: dataUser.tim,
          id: pickData.id,
          data: pickData,
          editDateKirim: dateKirim,
          dateBefore: dateBefore,
        },
        dataUser.auth,
        "",
        ""
      );
      setIsRefresh(true);
      handleClosePopUpPickTanggal();
    }
  };

  const handleImportPo = () => {
    if (file) {
      const reader = new FileReader();

      reader.onload = async (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet);

        await axios.post(
          `${process.env.REACT_APP_ENDPOINT}/importPo`,
          { data: json, tim: dataUser.tim },
          {
            headers: {
              Authorization: `Bearer ${dataAuth}`,
            },
          }
        );
      };
      reader.readAsBinaryString(file);
      setFile(null);
      setPopUpImportPo(false);
    }
  };

  const handleExportTemplateImportPo = () => {
    const filteredDataExcel = [
      {
        customer: "GS",
        noPo: "4500021782	",
        kodeBarang: "M2P2PA62RCM",
        noLine: 12,
        noSkk: "064/TIM/2025",
        kodeLine: 32,
        totalPo: 1000,
        tglKirim: "'01/09/2025",
        jumlahKirim: 1000,
      },
    ];

    const workSheet = XLSX.utils.json_to_sheet(
      filteredDataExcel && filteredDataExcel
    );

    workSheet["!cols"] = [
      { wch: 8 },
      { wch: 9 },
      { wch: 28 },
      { wch: 6 },
      { wch: 12 },
      { wch: 8 },
      { wch: 8 },
      { wch: 11 },
      { wch: 12 },
    ];
    const workBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workBook, workSheet, "List Po");
    XLSX.write(workBook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workBook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workBook, `Template Import PO.xlsx`);
  };

  const handleChangeEditPo = (event, type, id) => {
    let data = [...dataListPo];

    const targetObject = data.find((item) => item.id === id);

    if (type === "customer") {
      targetObject[event.target.name] = event.target.value.toUpperCase();
    } else if (type === "noPo") {
      targetObject[event.target.name] = event.target.value.toUpperCase();
    } else if (type === "noLine") {
      targetObject[event.target.name] = event.target.value;
    } else if (type === "noSkk") {
      targetObject[event.target.name] = event.target.value.toUpperCase();
    }
    setDataListPo(data);
  };

  const handleKirimEditPo = () => {
    setIsEditPo(false);
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/editPo`,
      {
        tim: dataUser.tim,
        data: dataListPo,
      },
      dataUser.auth,
      "",
      ""
    );
  };

  /* =========================================================
     BARU: Surat Jalan otomatis, Tiket Cancellation, Riwayat
     ========================================================= */

  // postAxios di project ini tidak ditunggu, jadi refresh diberi jeda singkat
  const refreshAfterWrite = () => {
    setTimeout(() => {
      setIsRefresh(true);
      setIsRefreshMemoKirim(true);
      setIsRefreshMantap(true);
      setIsRefreshHistory(true);
    }, 600);
  };

  /* ----- checklist memo kirim ----- */
  const handleToggleMemo = (id) => {
    setSelectedMemoIds((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id]
    );
  };

  const handleToggleAllMemo = (ids) => {
    setSelectedMemoIds((prev) =>
      ids.every((i) => prev.includes(i))
        ? prev.filter((i) => !ids.includes(i))
        : [...new Set([...prev, ...ids])]
    );
  };

  /* ----- buat surat jalan (nomor digenerate di backend) ----- */
  const handleBuatSuratJalan = () => {
    if (disabledButton || selectedMemoIds.length === 0) return;
    setDisabledButton(true);
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/suratJalan`,
      {
        tim: dataUser.tim,
        date: filterDateMemoKirim,
        ids: selectedMemoIds,
      },
      dataUser.auth,
      "",
      ""
    );
    setSelectedMemoIds([]);
    refreshAfterWrite();
    setTimeout(() => setDisabledButton(false), 900);
  };

  /* ----- tiket cancellation ----- */
  const sjOptions = [
    ...new Set(
      (dataListMemo || [])
        .filter((e) => e.noSj && e.jumlah > 0 && !e.isBatal)
        .map((e) => e.noSj)
    ),
  ].sort();

  const handlePickNoSjCancel = (noSj) => {
    setCancelNoSj(noSj);
    setErrCancel("");
    setCancelItems(
      (dataListMemo || [])
        .filter((e) => e.noSj === noSj && e.jumlah > 0)
        .map((e) => ({
          _id: e._id,
          customer: e.customer,
          itemPo: e.itemPo,
          kodeBarang: e.kodeBarang,
          noPo: e.noPo,
          noLine: e.noLine,
          jumlahAsli: e.jumlah,
          jumlahCancel: e.jumlah, // dipakai saat dicentang (external); bisa dikurangi
          checked: false, // default tidak dicentang
        }))
    );
  };

  const handleOpenCancel = (noSj) => {
    setCancelType("internal");
    setCancelReason("");
    setErrCancel("");
    setCancelNoSj("");
    setCancelItems([]);
    setPopUpCancel(true);
    if (noSj) handlePickNoSjCancel(noSj);
  };

  const handleCloseCancel = () => {
    setPopUpCancel(false);
    setCancelNoSj("");
    setCancelType("internal");
    setCancelReason("");
    setCancelItems([]);
    setErrCancel("");
    setDisabledButton(false);
  };

  const handleToggleCancelItem = (id) => {
    setCancelItems((prev) =>
      prev.map((i) => (i._id === id ? { ...i, checked: !i.checked } : i))
    );
  };

  const clampQty = (value, max) =>
    Math.min(Math.max(Number(value) || 0, 0), max);

  const handleChangeCancelQty = (id, value) => {
    setCancelItems((prev) =>
      prev.map((i) =>
        i._id === id ? { ...i, jumlahCancel: clampQty(value, i.jumlahAsli) } : i
      )
    );
  };

  const handleStepCancelQty = (id, delta) => {
    setCancelItems((prev) =>
      prev.map((i) =>
        i._id === id
          ? {
              ...i,
              jumlahCancel: clampQty(
                Number(i.jumlahCancel) + delta,
                i.jumlahAsli
              ),
            }
          : i
      )
    );
  };

  const handleSubmitCancel = () => {
    // item yang dicentang = item bermasalah (internal: untuk riwayat saja,
    // semua item SJ tetap kembali ke memo kirim; external: yang dikurangi dari PO)
    const picked = cancelItems.filter(
      (i) => i.checked && Number(i.jumlahCancel) > 0
    );
    if (!cancelNoSj)
      return setErrCancel("Pilih No. Surat Jalan terlebih dahulu.");
    if (picked.length === 0)
      return setErrCancel(
        cancelType === "internal"
          ? "Centang minimal satu item yang bermasalah (jumlah lebih dari 0)."
          : "Centang minimal satu item dengan jumlah cancel lebih dari 0."
      );
    if (!cancelReason.trim())
      return setErrCancel("Keterangan cancel wajib diisi.");
    if (disabledButton) return;

    setDisabledButton(true);
    postAxios(
      `${process.env.REACT_APP_ENDPOINT}/cancelSuratJalan`,
      {
        tim: dataUser.tim,
        noSj: cancelNoSj,
        type: cancelType,
        reason: cancelReason.trim(),
        createdBy: dataUser.name || dataUser.role,
        items: picked.map((i) => ({
          _id: i._id,
          jumlahCancel: Number(i.jumlahCancel),
        })),
      },
      dataUser.auth,
      "",
      ""
    );
    handleCloseCancel();
    refreshAfterWrite();
  };

  return {
    popUpNewPo,
    setPopUpNewPo,
    customerNewPo,
    setCustomerNewPo,
    noPo,
    setNoPo,
    noLine,
    setNoLine,
    kodeLine,
    setKodeLine,
    itemPo,
    setItemPo,
    totalPo,
    setTotalPo,
    jadwalKirim,
    addFields,
    removeFields,
    handleFormChange,
    handleCloseNewPo,
    handleTambahPo,
    dataListTempPo,
    handleDeleteTempPo,
    dateTemp,
    errIsEmpty,
    handleKirimPo,
    bulanPo,
    setBulanPo,
    tahunPo,
    setTahunPo,
    dataListBarangTemp,
    dataListPo,
    dateTempListPo,
    handlePickTanggal,
    popUpPickTanggal,
    handleClosePopUpPickTanggal,
    pickData,
    pickTanggal,
    dateKirim,
    setDateKirim,
    jumlahKirim,
    setJumlahKirim,
    setIsRefresh,
    handleKirimEditTanggal,
    handlePickJenis,
    isMaju,
    isMundur,
    isBuatMemoKirim,
    setIsBuatMemoKirim,
    handleKirimBatal,
    popUpCatatan,
    setPopUpCatatan,
    customerCatatan,
    setCustomerCatatan,
    keteranganCatatan,
    setKeteranganCatatan,
    handleUpdateCatatan,
    handleDeleteCatatan,
    setIsRefreshCatatan,
    dataListCatatan,
    handlePickChecklist,
    dataSuratJalanTemp,
    dataPickMemoKirim,
    handleCloseMemoKirim,
    handleCancelPickChecklist,
    isPecah,
    setIsPecah,
    pecahNoPol,
    addFieldsPecah,
    removeFieldsPecah,
    handleFormChangePecah,
    isPecahPick,
    setIsPecahPick,
    handleClickPecah,
    dateMemoKirim,
    setDateMemoKirim,
    noPol,
    setNoPol,
    handleKirimNoPol,
    removeSpaces,
    subMenu,
    setSubMenu,
    filterDateMemoKirim,
    setFilterDateMemoKirim,
    dataListMemo,
    handleFormChangeEditNoPol,
    handleSaveNoPol,
    handleExportExcel,
    setIsRefreshMemoKirim,
    handleDeleteMemoKirim,
    filterCustomer,
    setFilterCustomer,
    valueSearch,
    setValueSearch,
    dataTemp,
    handleResetFilter,
    dataMirrorMemoKirim,
    disabledButton,
    setDisabledButton,
    checkingRole,
    dataBarangJadi,
    dataUser,
    dataMirrorSj,
    valueSearchMemo,
    setValueSearchMemo,
    dataTempMemoSearch,
    handleDeleteJadwal,
    errPecah,
    noSkk,
    setNoSkk,
    setIsRefreshMantap,
    popUpImportPo,
    setPopUpImportPo,
    file,
    setFile,
    handleImportPo,
    handleExportTemplateImportPo,
    handleChangeEditPo,
    isEditPo,
    setIsEditPo,
    handleKirimEditPo,

    // baru
    selectedMemoIds,
    handleToggleMemo,
    handleToggleAllMemo,
    handleBuatSuratJalan,
    popUpCancel,
    cancelNoSj,
    cancelType,
    setCancelType,
    cancelReason,
    setCancelReason,
    cancelItems,
    errCancel,
    sjOptions,
    handleOpenCancel,
    handleCloseCancel,
    handlePickNoSjCancel,
    handleToggleCancelItem,
    handleChangeCancelQty,
    handleStepCancelQty,
    handleSubmitCancel,
    dataHistoryCancel,
    filterBulanHistory,
    setFilterBulanHistory,
    setIsRefreshHistory,
  };
};
